/**
 * Specifies the side of the relative value.
 * tag: 2532
 * @readonly
 * @enum {number} (int)
 */
export enum RelativeValueSide {
  /** Bid */
  Bid = 1,
  /** Mid */
  Mid = 2,
  /** Offer */
  Offer = 3,
}
